import { FloorplanItemTextKonva } from "@project/floorplanner/konva/floorplan-item-text-konva";
import { FloorplanWorkspaceKonvaAdapter } from "@project/floorplanner/konva/floorplan-workspace-konva.adapter";
import { LabelLayoutKonva } from "@project/floorplanner/konva/label-layout-konva";
import { Group } from "konva/lib/Group";
import { Text } from "konva/lib/shapes/Text";

export class ZoneKonva {
  static setTextPosition(itemText: Group, group: Group) {
    itemText.offsetY(0);
    itemText.offsetX(0);
    const item = group.getAttr(FloorplanWorkspaceKonvaAdapter.OBJECT_KEY);
    LabelLayoutKonva.placeLabelForItem(itemText, group, item);
  }

  static scaleText(itemText: Text, zoneGroup: Group) {
    const diagonal = Math.sqrt(zoneGroup.width() * zoneGroup.width() + zoneGroup.height() * zoneGroup.height());
    const diagonalFontSize = diagonal / 20;
    const minimumFontSize = 20;
    const maximumFontSize = 165;
    const finalSize = Math.max(minimumFontSize, Math.min(diagonalFontSize, maximumFontSize));
    itemText.fontSize(finalSize);
    const textGroup = itemText.getParent();
    if (textGroup instanceof Group) {
      FloorplanItemTextKonva.updateBackground(textGroup);
    }
  }

  static resizeZoneGroup(parentGroup: Group, width: number, height: number) {
    parentGroup.width(width);
    parentGroup.height(height);

    const zoneGroup = parentGroup.getChildren()[0] as Group;
    zoneGroup.width(width);
    zoneGroup.height(height);

    zoneGroup.getChildren().forEach((child) => {
      if (child.getClassName() === "Rect") {
        child.width(width);
        child.height(height);
      }
    });

    return zoneGroup;
  }
}
